'use strict';

import _ from 'lodash';
import React from 'react';

'use strict';

class Analytics extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			trackerSection: 'conferences',
			trackerView: this.props.view ? this.props.view : 'home',
			trackerViewSubTier: this.props.subTier ? this.props.subTier : '',
			trackerTitle: this.props.params.conference_id ? this.props.params.conference_id : '',
			trackerYear: this.props.params.year ? this.props.params.year : '',
			mounted: false,
			trackerExecute: true
		};

		/* start: tracker was executing twice in browser load when there was a subTier, set traps (sponsor, speaker) so it executes only once */
		if (typeof this.props.params.sponsor_id != "undefined") {
			if (this.props.params.sponsor_id != this.state.trackerViewSubTier) {
				this.state.trackerExecute = false;
			}
		}

		if (typeof this.props.params.speaker_id != "undefined") {
			if (this.props.params.speaker_id != this.state.trackerViewSubTier) {
				this.state.trackerExecute = false;
			}
		}
		/* end: tracker was executing twice in browser load when there was a subTier, set traps (sponsor, speaker) so it executes only once */

	}

	componentDidMount() {
		this.state.mounted = true;
	}

	render() {

		/* upon initial load the component renders three times, set a trap to have it render only once JTG */
		if (this.state.mounted === false && this.state.trackerExecute === true) {
			s.clearVars();
		

			s.pageName = this.state.trackerSection + ':' + this.state.trackerYear + ':' + this.state.trackerTitle + ':' + this.state.trackerView + (this.state.trackerViewSubTier ? ':' + this.state.trackerViewSubTier : '');
			s.channel = this.state.trackerSection;
			s.prop1 = s.eVar1 = this.state.trackerTitle;
			s.prop2 = s.eVar2 = this.state.trackerYear; // need year here
			s.prop3 = s.eVar3 = this.state.trackerView;
			s.prop25 = s.eVar27 = this.state.trackerSection;
			s.prop29 = s.eVar31 = this.state.trackerSection;
			void(s.t());
		}
		return null;
	}
}

export default Analytics;